import { AuthForm } from "../components/auth/AuthForm";

export function LoginPage() {
  return <AuthForm mode="login" />;
}
